import { Decimal } from 'decimal.js';
import { CurrencyCode, getCurrencyDecimalPlaces } from '@insio/shared-types';

/**
 * Rounds a decimal to the appropriate number of decimal places for the given currency.
 * The currency code is used to determine the decimal precision (e.g. 2 for EUR, 0 for JPY).
 * @param amount The decimal amount to round.
 * @param currencyCode The ISO currency code (e.g. 'EUR', 'USD', 'JPY'). If not provided, defaults to 2 decimal places.
 * @returns The amount rounded to the currency's decimal precision.
 */
export function roundToCurrencyPrecision(amount: Decimal, currencyCode?: CurrencyCode): Decimal {
  const decimals = currencyCode ? getCurrencyDecimalPlaces(currencyCode) : 2;
  return amount.toDecimalPlaces(decimals);
}
